// Canadian security industry keyword library.
// Used to enrich SEO metadata and page-level keyword clouds
// across every service, city, region, and combo landing page.
// URLs unchanged — this file only adds keyword breadth.

export const CANADA_CORE = [
  "security services Canada",
  "Canadian security guards",
  "licensed security company Canada",
  "24/7 security services Canada",
  "national security company BC",
  "Canadian security industry",
  "professional security guards Canada",
  "commercial security services Canada",
  "industrial security Canada",
  "residential security Canada",
];

export const CANADA_COMPLIANCE = [
  "WorkSafeBC compliant security",
  "BC Security Programs Division",
  "BC Security Worker License",
  "Advanced Security Training AST",
  "Occupational First Aid OFA-1 security",
  "Canadian Firearms Program compliant",
  "RCMP coordination security",
  "Transport Canada MTSR compliance",
  "Canadian Coast Guard liaison",
  "CBSA restricted zone security",
  "Cannabis Act compliant security",
  "Health Canada licensed producer security",
  "BC Liquor and Cannabis Regulation Branch",
  "PIPEDA compliant reporting",
  "ISO 18788 private security operations",
  "PSISA style standards Canada",
];

export const CANADA_INDUSTRY = [
  "oil and gas security Canada",
  "LNG facility security BC",
  "pipeline security Canada",
  "hydroelectric dam security BC",
  "utilities security Canada",
  "telecom tower security BC",
  "port terminal security Canada",
  "airport perimeter security",
  "rail yard security Canada",
  "cold storage security Canada",
  "warehouse and distribution security",
  "manufacturing plant security",
  "forestry site security BC",
  "aggregate quarry security",
  "hospital and healthcare security Canada",
  "long-term care facility security",
  "cannabis cultivation security Canada",
  "microFIT and utility solar site security",
  "film set security BC",
  "documentary and production security Canada",
];

export const CANADA_SERVICES = [
  "mobile patrol Canada",
  "vehicle patrol security British Columbia",
  "GPS verified patrols Canada",
  "uniformed security officer Canada",
  "plain-clothes loss prevention Canada",
  "concierge security Canada",
  "fire watch service Canada",
  "AHJ approved fire watch",
  "alarm response Canada",
  "keyholder services BC",
  "close protection Canada",
  "executive protection BC",
  "residential estate security Canada",
  "cannabis retail security Canada",
  "event and festival security Canada",
  "corporate front-desk security Canada",
  "parking enforcement Canada",
  "workplace investigations Canada",
  "WCB fraud investigation BC",
  "surveillance private investigator Canada",
];

export const CANADA_REGIONS = [
  "security Metro Vancouver",
  "security Fraser Valley",
  "security Vancouver Island",
  "security Sunshine Coast BC",
  "security Sea-to-Sky corridor",
  "security Okanagan Valley",
  "security Kootenays",
  "security Cariboo",
  "security Peace Region",
  "security Northern BC",
  "security Northwest BC",
  "security North Coast BC",
  "security Thompson-Nicola",
  "security Columbia-Shuswap",
];

export const CANADA_LONGTAIL = [
  "affordable security guards BC",
  "hire security guards British Columbia",
  "commercial security company near me BC",
  "night patrol security BC",
  "weekend security guards Vancouver",
  "temporary security guards British Columbia",
  "emergency security response Canada",
  "same-day security guards BC",
  "female security guards BC",
  "bilingual security officers Canada",
  "First Nations engagement security BC",
  "protest response security Canada",
  "picket line and labour dispute security",
  "vaccination clinic security BC",
  "COVID-19 event compliance security Canada",
  "insurance-approved security company Canada",
  "bonded and insured security BC",
  "TSSA and boiler watch security Canada",
];

export const ALL_CANADA_KEYWORDS = [
  ...CANADA_CORE,
  ...CANADA_COMPLIANCE,
  ...CANADA_INDUSTRY,
  ...CANADA_SERVICES,
  ...CANADA_REGIONS,
  ...CANADA_LONGTAIL,
];

// A curated smaller set that gets injected into every page's <meta keywords>
export const CANADA_KEYWORDS_FOR_META = [
  "security services Canada",
  "Canadian security company",
  "licensed security guards BC",
  "WorkSafeBC compliant security",
  "BC Security Worker License",
  "24/7 security services British Columbia",
  "insured and bonded security Canada",
  "commercial security Canada",
  "industrial security British Columbia",
  "mobile patrol Canada",
];
